import type { DocumentTypePresetPayload } from '@Application/Organizations/Workflows/Actions/workflowCatalogFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The starting point offered when a document type is added to a group. `documentTypeKey` null is the
 * generic preset for a type with no dedicated one; prompts are `''` when the preset has none.
 */
class DocumentTypePresetView {
	readonly documentTypeKey: string | null;
	readonly systemPrompt: string;
	readonly contextPrompt: string;
	readonly reevaluationSystemPrompt: string;
	readonly reevaluationContextPrompt: string;
	readonly splitCalls: boolean;
	readonly sectionDependencies: Readonly<Record<string, readonly string[]>>;

	constructor(payload: DocumentTypePresetPayload) {
		this.documentTypeKey = payload.documentTypeKey;
		this.systemPrompt = payload.systemPrompt;
		this.contextPrompt = payload.contextPrompt;
		this.reevaluationSystemPrompt = payload.reevaluationSystemPrompt;
		this.reevaluationContextPrompt = payload.reevaluationContextPrompt;
		this.splitCalls = payload.splitCalls;
		this.sectionDependencies = payload.sectionDependencies;

		Object.freeze(this);
	}
}

export default DocumentTypePresetView;
